import { useNavigate } from 'react-router-dom';
import { multiFormatDateString, formatDateString } from '../../utils/DateConvertor';
import { useTranslation } from 'react-i18next';
import { FaArrowRight } from "react-icons/fa";

const PostCard = ({ post }) => {
  const navigate = useNavigate();
  const {t} = useTranslation("post")
  const translation = t("post-card")

  const handleClick = () => {
    navigate(`/detail/${post.slug}`);
  };

  return (
    <div
      onClick={handleClick}
      className="cursor-pointer bg-white dark:bg-gray-800 rounded-2xl shadow-lg transition-transform transform hover:bg-gray-100 dark:hover:bg-gray-900 w-full"
    >
      <div className="p-4">
        {/* Description */}
        <p className="text-gray-700 dark:text-gray-300 text-sm h-auto mb-2 truncate-2-lines">
          {post.description.length > 10090
            ? `${post.description.substring(0, 100)}...`
            : post.description}
        </p>

        {/* Divider */}
        <hr className="my-3 border-t border-gray-200 dark:border-gray-600" />

        {/* Stats */}
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-7 gap-2 text-center">
          <StatButton label={translation.created} count={multiFormatDateString(post.created)} />
          <StatButton className="hidden md:block" label={translation.comments} count={post.comment_count} />
          
          {/* <StatButton label={translation.upvotes} count={post.upvote_count} /> */}
          <StatButton label={translation.donors} count={post.donors_count} />
          <StatButton label={translation.views} count={post.views} />
          <StatButton label={translation.for} count={post.post_type}  />
          <StatButton label={translation.needs} count={post.needed_money} />
          <StatButton label={translation.need_before} count={formatDateString(post.need_before)} />
        </div>

        <div className='md:hidden mt-2'>
          <hr />
          <p className='flex justify-center align-middle bg-blue-700 rounded-xl mt-2 text-white'>
            {translation.click_to_view} <span className='mt-1 ml-2'><FaArrowRight /></span>
          </p>

        </div>

      </div>
    </div>
  );
};

const StatButton = ({ className, label, count }) => {
  return (
    <div className={`flex flex-col items-center ${className}`}>
      <p className="font-semibold text-gray-600 dark:text-gray-400 text-xs">{label}</p>
      <span className="font-bold text-gray-800 dark:text-white text-xs">{count}</span>
    </div>
  );
};

export default PostCard;